<template>
  <div>
    <custom-toolbar
      :total="$store.getters['referral/total']"
      title="Referrals"
      @refresh="getReferrals"
    />
    <v-card class="mb-6 mt-6">
      <!-- Search/Filter fields can be added here similar to Partners.vue -->
       <div class="m-2">
        <v-row class="ml-5 mr-5">
           <v-col cols="12" md="4">
              <v-text-field
                v-model="$store.state.referral.field.search"
                label="Rechercher"
                outlined
                dense
                clearable
                @input="getReferralsByFields"
              ></v-text-field>
           </v-col>

        </v-row>
      </div>
    </v-card>
    <v-card>
      <v-data-table
        :loading="loading"
        loading-text="Chargement.."
        :headers="headers"
        :items="$store.getters['referral/referrals']"
        :items-per-page="$store.state.referral.field.paginate"
        :page.sync="currentPage"
        dense
        hide-default-footer
        @page-count="currentPage = $event"
      >
        <template #[`item.created_at`]="{item}">
          {{ formattingDate(item.created_at) }}
        </template>

         <template #[`item.partner`]="{item}">
          {{ item.partner ? (item.partner.name || item.partner.phone) : '-' }}
        </template>

         <template #[`item.user`]="{item}">
          {{ item.user ? (item.user.name || item.user.phone) : (item.user_id || '-') }}
        </template>
         <template #[`item.status`]="{item}">

        </template>

        <template #[`item.amount`]="{item}">
           {{ formatAmount(item.amount) }}
        </template>

         <template #[`item.status`]="{item}">
           <v-chip v-if="item.status === 1" small :color="getStatusColor(item.status)">Retiré</v-chip>
           <v-chip v-else small :color="getStatusColor(item.status)">Créé</v-chip>
        </template>

      </v-data-table>

      <v-card-text class="pt-2">
        <v-row>
          <v-col cols="2">
             <v-select
               v-model="$store.state.referral.field.paginate"
               :items="[10, 20, 50, 100]"
               label="Lignes par page"
               outlined
               dense
               hide-details
               @change="getReferralsByFields"
              ></v-select>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-pagination
              v-model="currentPage"
              total-visible="6"
              :length="lastPage"
              @input="getReferrals"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CustomToolbar from '@core/components/toolbar/CustomToolbar'
import { ref, onMounted } from '@vue/composition-api'
import store from '@/store'
import { formatDate } from '@core/date/dateFunctions'
import { intToCurrency } from '@core/dynamicComponents/dynamicComponents'

export default {
  name: 'Referrals',
  components: {
    CustomToolbar,
  },
  setup() {
    const loading = ref(false)
    const currentPage = ref(1)
    const lastPage = ref(1)

    const headers = [
      { text: 'PARTENAIRE', value: 'partner' },
      { text: 'UTILISATEUR', value: 'user' },
      { text: 'MONTANT', value: 'amount' },
      /*{ text: 'CODE', value: 'code' },*/
      /*{ text: 'TRAJET', value: 'road_id' },*/
      { text: 'STATUT', value: 'status' },
      { text: 'DATE', value: 'created_at' },
    ]

    const formattingDate = date => formatDate(date)
    const formatAmount = amount => intToCurrency(store.state.user.lang, {
      style: 'currency',
      currency: 'XAF',
      minimumFractionDigits: 0,
    }, amount)

    const getStatusColor = (status) => {
        // Simple heuristic, can be refined based on actual status values
        if (status === 'success' || status === 1 || status === 'valid') return 'success'
        if (status === 'pending' || status === 0) return 'warning'
        return 'secondary'
    }

    const getReferrals = (page = 1) => {
      loading.value = true
      store.dispatch('referral/getReferralsList', { page, field: store.state.referral.field }).then(() => {
        currentPage.value = store.getters['referral/current_page']
        lastPage.value = store.getters['referral/last_page']
        loading.value = false
      }).catch(error => {
        console.error(error)
        loading.value = false
      })
    }

    const getReferralsByFields = () => {
         getReferrals(1)
    }

    onMounted(() => {
      getReferrals()
    })

    return {
      headers,
      loading,
      currentPage,
      lastPage,
      getReferrals,
      formattingDate,
      formatAmount,
      getReferralsByFields,
      getStatusColor
    }
  }
}
</script>
